import { useContext, useState } from "react";
import { Card, ToastContainer } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import CButton from "../../../../components/buttons/Button";
import CCheckbox from "../../../../components/inputBoxes/checkbox";
import CEmailField from "../../../../components/inputBoxes/email-input";
import CUrlField from "../../../../components/inputBoxes/url-input";
import { SignUpFormHooks } from "../hooks/useSignup";
import { LoadingContext } from "../../../../context/loadingContext";
import CComparePassword from "../../../../components/inputBoxes/comparePassword-input";
import Cookies from "js-cookie";
import { error } from "../../../../components/alertMessagesHandler/alert";
import GoogleButton from "react-google-button";
import PrivacyPolicy from "../../../../pages/PrivacyPolicy";

const SignupForm = (props) => {
  const { setLoading } = useContext(LoadingContext);
  let navigate = useNavigate();
  const [FieldValues, setFieldValues] = useState();

  const privacy =
    '<p>I declare that I have read and accepted the <a href="/privacy-policy"> privacy policy </Link></p>';

  //  Register domain using SignUpFormHooks

  const signUpHandle = async () => {
    setLoading(true);
    const result = await SignUpFormHooks(FieldValues);
    if (result.status === 200) {
      for (const [key, value] of Object.entries(result.data)) {
        Cookies.set(key, value);
      }
      setLoading(false);
      props.setReg(true);
      navigate("/otp");
    } else {
      setLoading(false);
      error(result.message);
    }
  };

  // Handles fields input value

  const HandleFieldValues = (key, value) => {
    setFieldValues({ ...FieldValues, [key]: value });
  };

  // On form submission

  const submit = (event) => {
    event.preventDefault();
    if (FieldValues.password !== undefined && FieldValues.password !== "") {
      signUpHandle();
    }
  };

  return (
    <>
      <div className="bg-img">
        <div className="container">
          <div className="row m-0">
            <div className="col-md-2 col-lg-6 col-sm-12"></div>
            <div className="col-md-10 col-lg-6 col-sm-12">
              <form onSubmit={submit}>
                <Card
                  className="py-5 border border-0 rounded-0"
                  style={{ minHeight: "100vh" }}
                >
                  <div className="container mb-5">
                    <div className="row">
                      <div className="col-md-2 col-lg-1"></div>
                      <div className="col-md-8 col-lg-10 col-sm-8">
                        <Card.Body>
                          <Card.Title
                            className="text-center mb-4 mt-3"
                            style={{ color: "#044389" }}
                          >
                            <h4 className="fw-bolder">Sign Up For Free</h4>
                          </Card.Title>
                          <CEmailField
                            required={true}
                            customClassDiv={"mb-4"}
                            customClassInput={"bg-primary-soft w-75"}
                            labelName={"Email"}
                            name={"email"}
                            placeholder={"12345678@gmail.com"}
                            customClassLabel={"text-primary-new"}
                            functionName={(name, email) =>
                              HandleFieldValues(name, email)
                            }
                          />
                          <CUrlField
                            required={true}
                            customClassInput={"bg-primary-soft w-75"}
                            pattern={"\\w+\\.\\w+(\\.\\w+)?"}
                            labelName={"Website URL"}
                            name={"portal_url"}
                            placeholder={"domain.xyz"}
                            customClassLabel={"text-primary-new"}
                            functionName={(name, portal_url) =>
                              HandleFieldValues(name, portal_url)
                            }
                          />
                          <small className="text-danger">
                            Please use your plain URL. No http, https, or www.
                            We do not accept sites on{" "}
                            <a href="#">blogpost.com</a>, Instagram URL's or
                            social media pages.
                          </small>
                          <CComparePassword
                            required={true}
                            labelName1={"New Password"}
                            labelName2={"Confirm Password"}
                            name1={"password"}
                            name2={"ConPass"}
                            placeholder1={"Enter Password"}
                            placeholder2={"Confirm Password"}
                            customClassRowDiv={"mb-4 mt-4"}
                            customClassInput={"bg-primary-soft"}
                            customClassLabel={"text-primary-new"}
                            customStyleLabel={{ fontSize: "15px" }}
                            functionName={(name1, pass) =>
                              HandleFieldValues(name1, pass)
                            }
                          />
                          <CCheckbox
                            customClassDiv={"mb-4"}
                            customClassInputDiv={"mb-2"}
                            customClassLabel={"text-primary-new mt-2 mb-3"}
                            labelName={"Terms & Conditions"}
                            spanLabel={"*"}
                            customClassSpanLabel={"text-danger ms-1 fw-bold"}
                            choiceListArray={[
                              {
                                html: true,
                                value: "con-1",
                                label: privacy,
                                required: true,
                              },
                              {
                                value: "con-2",
                                label:
                                  "I acknowledge the use of automated calling systems for direct marketing of services and goods offered by Next Health Media LLC and Entities interested in marketing their own goods or services",
                                required: true,
                              },
                              {
                                value: "con-3",
                                label:
                                  "I consent to be sent all kinds of health related commercial information via electronic means of communication regarding direct marketing of services and goods offered by Next Health Media LLC and entities interested in marketing their own goods and services",
                                required: true,
                              },
                            ]}
                          />
                          <CButton
                            btnClassesDiv={"text-center mt-4"}
                            btnClasses={"btn px-4 fw-bold text-white"}
                            IsOutline={false}
                            innertext={"Next"}
                            btnCustomStyle={{
                              backgroundColor: "#044389",
                            }}
                          />
                          {/* <h5 className="text-dark text-center mt-4 fw-bold">
                            Or
                          </h5> */}
                          {/* <CButton
                            btnClassesDiv={"text-center mt-4"}
                            btnClasses={"btn px-4 fw-bold"}
                            IsOutline={true}
                            innertext={"Sign-Up with Google"}
                            faIcon={faG}
                            faClass={"me-3 fa-xl"}
                            btnCustomStyle={{
                              color: "#044389",
                              border: "1px solid #044389",
                            }}
                          /> */}
                          {/* <GoogleButton
                            type="light"
                            onClick={() => {
                              console.log("Google button clicked");
                            }}
                            className={"text-dark mt-4 mx-auto"}
                          /> */}
                        </Card.Body>
                      </div>
                    </div>
                  </div>
                </Card>
              </form>
              <div className="col-md-2 col-lg-1"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignupForm;
